// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as BigJs from "big.js";
import * as OrderEdit from "../../app/Order/OrderEdit.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as OrderStatus from "./OrderStatus.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Accounting__Utils from "@wino/accounting/src/Accounting__Utils.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as ProductPriceTableCell from "../Product/ProductPriceTableCell.res.js";
import * as ProductStockTableCell from "../Product/ProductStockTableCell.res.js";
import * as CartProductTaxTableCell from "../Cart/CartProductTaxTableCell.res.js";
import * as CartProductFeesTableCell from "../Cart/CartProductFeesTableCell.res.js";
import * as CartProductQuantityTableCell from "../Cart/CartProductQuantityTableCell.res.js";
import * as CartProductDiscountsTableCell from "../Cart/CartProductDiscountsTableCell.res.js";
import * as CartProductUnitPriceTableCell from "../Cart/CartProductUnitPriceTableCell.res.js";
import * as LegacyProductReferenceTableCell from "../Product/LegacyProductReferenceTableCell.res.js";

let ProductTaxNotFound = /* @__PURE__ */Primitive_exceptions.create("OrderCartTable.ProductTaxNotFound");

function keyExtractor(row) {
  return row._0.id;
}

function tableColumns(statuses, hidden, taxesFree, editable, onRequestDispatch) {
  return [
    {
      key: "line",
      name: I18n.t("Line"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 65
        },
        width: {
          NAME: "px",
          VAL: 65
        }
      },
      render: param => {
        let value = param.index + 1 | 0;
        let string = value.toString();
        let length = 4;
        let formattedLineNumber = string.padStart(length, "0");
        return JsxRuntime.jsx(TextStyle.make, {
          children: formattedLineNumber,
          variation: "normal",
          size: "xsmall"
        });
      }
    },
    {
      key: "reference",
      name: I18n.t("Product"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 250
        },
        width: {
          NAME: "fr",
          VAL: 3
        },
        margin: "large",
        sticky: true
      },
      render: param => {
        let product = param.data;
        let match;
        if (product.TAG === "Unit") {
          let match$1 = product._0;
          match = [
            match$1.identifier,
            match$1.name,
            match$1.description
          ];
        } else {
          let match$2 = product._0;
          match = [
            match$2.identifier,
            match$2.name,
            match$2.description
          ];
        }
        return JsxRuntime.jsx(LegacyProductReferenceTableCell.make, {
          id: match[0],
          name: match[1],
          description: match[2],
          errorMessage: param.errorMessage,
          openNewTab: true
        });
      }
    },
    {
      key: "stock",
      name: I18n.t("Current stock"),
      layout: {
        hidden: hidden === "StatusAtAfterReception",
        minWidth: {
          NAME: "px",
          VAL: 80
        },
        width: {
          NAME: "pct",
          VAL: 7
        },
        alignX: editable ? "flexStart" : "center"
      },
      render: param => {
        let product = param.data;
        let formattedStock;
        let exit = 0;
        let formattedStock$1;
        if (product.TAG === "Unit") {
          formattedStock$1 = product._0.formattedStock;
          exit = 1;
        } else {
          formattedStock$1 = product._0.formattedStock;
          exit = 1;
        }
        if (exit === 1) {
          formattedStock = Stdlib_Option.map(formattedStock$1, value => value.replace(".", ","));
        }
        return JsxRuntime.jsx(ProductStockTableCell.make, {
          value: formattedStock
        });
      }
    },
    {
      key: "quantity",
      name: I18n.t("Ord. qt"),
      layout: {
        hidden: hidden === "StatusAtAfterReception",
        minWidth: {
          NAME: "px",
          VAL: 140
        },
        width: {
          NAME: "fr",
          VAL: 1.5
        },
        alignX: editable ? "flexStart" : "center"
      },
      render: param => JsxRuntime.jsx(CartProductQuantityTableCell.make, {
        product: param.data,
        editable: editable,
        onRequestDispatch: onRequestDispatch
      })
    },
    {
      key: "reception_quantity",
      name: I18n.t("Rec. qt"),
      layout: {
        hidden: hidden === "StatusBeforeReception",
        minWidth: {
          NAME: "px",
          VAL: 170
        },
        alignX: editable && !OrderEdit.isLimitedEdition(statuses) ? "flexStart" : "center"
      },
      render: param => JsxRuntime.jsx(CartProductQuantityTableCell.make, {
        product: param.data,
        editable: editable && !OrderEdit.isLimitedEdition(statuses),
        beforeOrderReception: false,
        onRequestDispatch: onRequestDispatch
      })
    },
    {
      key: "unitPrice",
      name: I18n.t("U. price excl. VAT"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 170
        },
        width: {
          NAME: "fr",
          VAL: 1.5
        },
        margin: "normal"
      },
      render: param => JsxRuntime.jsx(CartProductUnitPriceTableCell.make, {
        product: param.data,
        editable: editable,
        onRequestDispatch: onRequestDispatch
      })
    },
    {
      key: "discounts",
      name: I18n.t("U. discounts"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        }
      },
      render: param => JsxRuntime.jsx(CartProductDiscountsTableCell.make, {
        editable: editable,
        product: param.data,
        onRequestDispatch: onRequestDispatch
      })
    },
    {
      key: "fees",
      name: I18n.t("U. fees"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        }
      },
      render: param => JsxRuntime.jsx(CartProductFeesTableCell.make, {
        editable: editable,
        product: param.data,
        onRequestDispatch: onRequestDispatch
      })
    },
    {
      key: "amount",
      name: I18n.t("Total excl. VAT"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        }
      },
      render: param => {
        let product = param.data;
        let formattedTotalAmountExcludingGlobalDiscounts;
        let exit = 0;
        let totalAmountExcludingGlobalDiscounts;
        if (product.TAG === "Unit") {
          totalAmountExcludingGlobalDiscounts = product._0.totalAmountExcludingGlobalDiscounts;
          exit = 1;
        } else {
          totalAmountExcludingGlobalDiscounts = product._0.totalAmountExcludingGlobalDiscounts;
          exit = 1;
        }
        if (exit === 1) {
          formattedTotalAmountExcludingGlobalDiscounts = Stdlib_Option.map(totalAmountExcludingGlobalDiscounts, value => I18n.currencyFormat(undefined, "EUR", 3, 3, value.toNumber()));
        }
        return JsxRuntime.jsx(ProductPriceTableCell.make, {
          value: formattedTotalAmountExcludingGlobalDiscounts
        });
      }
    },
    {
      key: "amountVAT",
      name: I18n.t("VAT total"),
      layout: {
        hidden: taxesFree,
        minWidth: {
          NAME: "px",
          VAL: 135
        }
      },
      render: param => {
        let product = param.data;
        let totalTaxesExcludingGlobalDiscount;
        let taxes;
        if (product.TAG === "Unit") {
          let match = product._0;
          let taxes$1 = match.taxes;
          if (taxes$1 === undefined) {
            return null;
          }
          totalTaxesExcludingGlobalDiscount = match.totalTaxesExcludingGlobalDiscount;
          taxes = taxes$1;
        } else {
          let match$1 = product._0;
          let taxes$2 = match$1.taxes;
          if (taxes$2 === undefined) {
            return null;
          }
          totalTaxesExcludingGlobalDiscount = match$1.totalTaxesExcludingGlobalDiscount;
          taxes = taxes$2;
        }
        let match$2 = taxes[0];
        if (taxesFree) {
          throw {
            RE_EXN_ID: ProductTaxNotFound,
            Error: new Error()
          };
        }
        let productTax;
        if (match$2 !== undefined) {
          productTax = match$2;
        } else {
          throw {
            RE_EXN_ID: ProductTaxNotFound,
            Error: new Error()
          };
        }
        let taxAmount = Accounting__Utils.bigToFloat(Stdlib_Option.getOr(totalTaxesExcludingGlobalDiscount, BigJs.Big(0)));
        return JsxRuntime.jsx(CartProductTaxTableCell.make, {
          taxAmount: taxAmount,
          taxRate: productTax.rate
        });
      }
    },
    {
      key: "actions",
      layout: {
        hidden: (!editable || OrderStatus.has(statuses, "ARCHIVED") || hidden === "StatusAtAfterReception") && !OrderStatus.has(statuses, "DRAFT"),
        minWidth: {
          NAME: "px",
          VAL: 80
        },
        width: {
          NAME: "px",
          VAL: 80
        },
        alignX: "flexEnd",
        sticky: true
      },
      render: param => {
        let product = param.data;
        let productId;
        productId = product._0.id;
        return JsxRuntime.jsx(Button.make, {
          shape: "pill",
          icon: "delete",
          onPress: () => onRequestDispatch({
            TAG: "ProductRemoved",
            _0: productId
          })
        });
      }
    }
  ];
}

let make = TableView.make;

export {
  ProductTaxNotFound,
  keyExtractor,
  tableColumns,
  make,
}
/* I18n Not a pure module */
